// extracted by mini-css-extract-plugin
export default {"container":"Video_container_iL7w0","title":"Video_title_woWrS","video":"Video_video_c948z"};